import React from 'react';

import classNames from 'classnames';

import COLORS from '../../../constants/colors.constants';

const CaretRightIcon = ({
  className,
  fill = COLORS.brand,
  size = 24,
  ...rest
}) => (
  <svg
    className={classNames(className)}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...rest}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      fill={fill}
      d="M7.96998 5.22001C8.11061 5.07956 8.30123 5.00067 8.49998 5.00067C8.69873 5.00067 8.88936 5.07956 9.02998 5.22001L15.28 11.47C15.4204 11.6106 15.4993 11.8013 15.4993 12C15.4993 12.1988 15.4204 12.3894 15.28 12.53L9.02998 18.78C8.88781 18.9125 8.69976 18.9846 8.50546 18.9812C8.31116 18.9778 8.12577 18.899 7.98836 18.7616C7.85095 18.6242 7.77223 18.4388 7.7688 18.2445C7.76538 18.0502 7.8375 17.8622 7.96998 17.72L13.69 12L7.96998 6.28001C7.82953 6.13939 7.75064 5.94876 7.75064 5.75001C7.75064 5.55126 7.82953 5.36064 7.96998 5.22001Z"
    />
  </svg>
)

export default CaretRightIcon;
